// extracted by mini-css-extract-plugin
export default {"addToCartControl":"q0-z","giftCard":"r0-z","btnContainer":"s0-z","cartButton":"t0-z","disabled":"u0-z"};